import React from "react";
import { PageShell } from "./PageShell";
import { Hero } from "../components/sections/Hero";
import { Advantages } from "../components/sections/Advantages";
import { KeyFigures } from "../components/sections/KeyFigures";
import { MarqueeBand } from "../components/sections/MarqueeBand";

export default function Home() {
  return (
    <PageShell>
        <Hero />
        <Advantages />
        <KeyFigures />
        <MarqueeBand />
    </PageShell>
  );
}
